import { Icon, IconButton, ComponentTrackingType } from '@homebotapp/hb-react-component-catalog'

export interface ArrowButtonProps {
  onClick?: () => void
  className?: string
  isLeftArrow: boolean
  tracking?: ComponentTrackingType
  smallerButton?: boolean
}

const ArrowButton = ({ onClick, className, isLeftArrow, tracking, smallerButton = false }: ArrowButtonProps) => {
  const disabled = className?.includes('slick-disabled')

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    onClick?.()
  }

  return (
    <IconButton
      top='50%'
      zIndex={2}
      bg='neutral.50'
      onClick={handleClick}
      disabled={disabled}
      position='absolute'
      size={smallerButton ? 'xs' : ['xs', 'sm', 'md']}
      _hover={{ bg: 'neutral.200' }}
      transform='translate(0, -50%)'
      left={isLeftArrow ? 4 : 'auto'}
      right={isLeftArrow ? 'auto' : 4}
      aria-label={`${isLeftArrow ? 'previous' : 'next'} arrow button`}
      icon={isLeftArrow ? <Icon name='angle-left' /> : <Icon name='angle-right' />}
      tracking={tracking}
    />
  )
}

export default ArrowButton
